import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { beginSignIn } from "@/lib/oidc";
import { toast } from "@/hooks/useToast";

interface SignInDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SignInDialog({ open, onOpenChange }: SignInDialogProps) {
  async function handleSignIn() {
    try {
      const redirectUri = `${window.location.origin}/auth/callback`;
      // Preserve the current location so the user lands back where they started.
      const postLoginRedirect =
        window.location.pathname === "/" ? "/sessions" : window.location.pathname;
      await beginSignIn(redirectUri, postLoginRedirect);
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Sign in failed",
        description: err instanceof Error ? err.message : "Unknown error",
      });
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Sign in to Tabgraph</DialogTitle>
          <DialogDescription>
            You'll be redirected to Tabgraph's identity provider to sign in or
            create an account.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={() => { void handleSignIn(); }}>
            Continue to sign in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
